import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface SnackbarData {
  message: string;
  action?: string;
}

@Component({
  selector: 'hk-snack-bar-html-content',
  template: `
    <span [innerHTML]="data.message"></span>
    <button
      mat-button
      matsnackbaraction
      class="mat-mdc-snack-bar-action mdc-snackbar__action mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base"
      mat-ripple-loader-class-name="mat-mdc-button-ripple"
      *ngIf="data.action"
      (click)="snackBarReference.dismiss()"
    >
      <span class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span>
      <span class="mdc-button__label">{{ data.action | translate }}</span>
      <span class="mat-mdc-focus-indicator"></span>
      <span class="mat-mdc-button-touch-target"></span>
      <span class="mat-ripple mat-mdc-button-ripple"></span>
    </button>
  `,
  host: { class: 'flex items-center justify-between' },
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class SnackBarHtmlContentComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    protected snackBarReference: MatSnackBarRef<SnackBarHtmlContentComponent>,
  ) {}
}
